<script type="text/jsx">
import Edit, { CapacityConfigListFactory } from '@/plans/EVENT_SAAS/config/edit';
import mxPlanConfig from '@/plans/EVENT_SAAS_CORE/mixin';
import ConfigBase from '@/plans/EVENT_SAAS/config/base';
import { planTypes } from '@/common/constants';

export default {
  mixins: [Edit, mxPlanConfig],
  components: {
    CapacityConfigList: CapacityConfigListFactory(mxPlanConfig),
    ConfigBase: {
      mixins: [ConfigBase, mxPlanConfig],
    },
  },
  computed: {
    type(){
      return planTypes.EVENT_SAAS_CORE
    }
  }
};
</script>
